import { defineNuxtRouteMiddleware, navigateTo } from '#imports';
import { useRootService } from '@kaokei/use-vue-service';
import { UserService } from '~/services/user.service';

export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.client) {
    if (to.name === 'oj_home') {
      const userService = useRootService(UserService);
      const uid = to.query.id as string;
      const isMine = !uid || userService.user.uid === uid;
      const name = isMine ? 'oj_home_problem' : 'oj_home_post';
      return navigateTo({ name, query: to.query });
    }
  }
});
